import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MexicoCityIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                "clip-path": "url(#clip0_1809_2765)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.9788 18.884H6.31201V22.9999H12.9788V18.884Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M13.2931 18.1304H6L6.31241 18.8841H12.9792L13.2931 18.1304Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.6968 17.3279H6.5957V18.1301H12.6968V17.3279Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.4272 16.1404H7.86328V17.3278H11.4272V16.1404Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.1305 7.61304H8.16113V8.80049H11.1305V7.61304Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.48964 4.99243H9.10596V5.85232H9.48964V4.99243Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.187 4.99222V4.56152H9.10723V4.99222H10.187Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.1869 4.99243H9.80322V5.85232H10.1869V4.99243Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M9.83876 3.91724H9.45508V4.77712H9.83876V3.91724Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.8464 5.85229V6.4028C11.8464 6.66213 11.7645 6.90326 11.625 7.0989C11.4066 7.40979 11.0457 7.61301 10.6362 7.61301H8.65557C8.2461 7.61301 7.88516 7.40979 7.66526 7.0989C7.52574 6.90175 7.44385 6.66213 7.44385 6.4028V5.85229H11.8449H11.8464Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.8077 6.36914H8.48584V21.0023H10.8077V6.36914Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.4272 16.9231H7.86328V17.328H11.4272V16.9231Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.8077 15.7354H8.48584V16.1403H10.8077V15.7354Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.8077 7.63867H8.48584V8.04359H10.8077V7.63867Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.8077 6.36914H8.48584V6.77406H10.8077V6.36914Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M8.8087 3.83374V3.75488C8.77989 3.77308 8.8087 3.83374 8.8087 3.83374Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.4858 3.75488V3.83374C10.4858 3.83374 10.5131 3.7746 10.4858 3.75488Z",
                        fill: "#62D2F5"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.0629 1.40432L9.88853 1.75465V0.999406C9.88853 0.999406 9.71413 0.94481 9.64588 1.0267C9.57612 0.946326 9.40323 0.999406 9.40323 0.999406V1.75465L9.22883 1.40432L8.98315 1.22689V0.712778H9.19547L9.31679 0.271462L8.97254 0.00151655L8.64799 0.312409L8.80875 0.77799V1.10253L7.28613 0L7.44537 0.837135L8.7951 2.5387H9.22883V2.99822L8.7951 3.34854L8.80723 3.75649C8.82846 3.74133 8.88306 3.75194 9.01348 3.83535V4.07345H10.2783V3.83535C10.4087 3.75194 10.4633 3.74284 10.4845 3.75649L10.4967 3.34854L10.0629 2.99822V2.5387H10.4967L11.8464 0.837135L12.0056 0L10.0614 1.40432H10.0629Z",
                        fill: "#62D2F5"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1809_2765",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                    })
                })
            })
        ]
    });
